function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M320 160.2l13.8-13.2L448 256 333.8 365 320 351.8 420.4 256zM192 160.2L178.2 147 64 256l114.2 109 13.8-13.2L91.6 256z"
});

const SvgIosCode = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosCode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-code.adcb8b10.svg";
export { ForwardRef as ReactComponent };